import React from 'react'
import { Container, Button } from 'react-bootstrap'
import './styles.scss'
import { Link } from 'react-scroll'

function Moto() {
    return (
        <div id="Moto">
            <Container>
                <h1>Our Motto</h1>
                <p className="para">
                    Our motto is to create new innovative solutions for modren India. TeamTechSeminal ( TTS ) will fetch innovative solutions to the problems in our society. As long as this organisation exist we will do this service. We will encourage new starup ideas that can make a good change in our society as well as to our country. TechSeminal is not about ideas, it is about making ideas happen.                    <br /><br />
                    <span className="motospan">Connect to the world of Technology</span>
                    <br />
                    <Button className="Button" as={Link} to="Joinus" smooth={true} duration={300}>JOIN US 😇 </Button>
                </p>
            </Container>
        </div>
    )
}

export default Moto
